import { ChakraProps } from '@aloft/toolkit-sui/chakra';

import { HEADER_HEIGHT_IN_PX } from './constants';
import { isPinned } from './isPinned.ts';

const BORDER_HEIGHT_PX = 3;

export function getPinnedRowStyles(
  shouldPinFirstRow: boolean | number,
  rowIndex: number,
): ChakraProps {
  return isPinned(shouldPinFirstRow, rowIndex)
    ? {
        position: 'sticky',
        top: `${HEADER_HEIGHT_IN_PX * (rowIndex + 1) + BORDER_HEIGHT_PX * rowIndex}px`,
        zIndex: '1',
      }
    : {};
}
